<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Tambah Pesanan</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Ubah</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Hapus</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Ekspor
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Tutup
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6" class="pr-5">
          <b-input-group>
            <b-input-group-prepend>
              <label>No Order Iklan</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.noorderiklan" placeholder="No Order"></b-form-input>
            <b-input-group-prepend>
              <span class="p-2">Customer</span>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.CustName" style="width:27% !important;" 
              @keyup.13.native="lkuKoranCustShow=true" @change="tblData.customer_id=''"
              placeholder="Kode atau Nama"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCustShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode Kirim</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">s.d</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Alamat</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.address" placeholder="Alamat"></b-form-input>
            <!-- <b-row>
              <b-col class="pr-1" cols="5">
                <b-form-input v-model="tblData.invdate" type="date" placeholder="Invoice Date"></b-form-input>
              </b-col>
              <b-col class="pl-1" cols="6">
                <b-form-input v-model="tblData.invoiceno" placeholder="Nomor Invoice"></b-form-input>
              </b-col>
            </b-row>-->
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Kota</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.City" placeholder="Kota"></b-form-input>
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()">
              <i class="fa fa-refresh"></i> Terapkan Filter
            </b-button>
            <b-button class="btn btn-secondary" @click="clearFilter()">
              <i class="fa fa-eraser"></i> Hapus Filter
            </b-button>
          </b-input-group>
        </b-col>
      </b-row>
      <br />
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(Address)="data">
          {{ data.item.Address1 }}
          {{ data.item.Address2 }}
        </template>
        <template v-slot:cell(PhoneNo)="data">
          <span v-if="(data.item.PhoneNo)">P.{{data.item.PhoneNo}}</span>&nbsp;
          <span v-if="(data.item.FaxNo)">F.{{data.item.FaxNo}}</span>
        </template>
        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-input-group style="width: 224px;">
            <b-input-group-prepend class="mb-0">
              <label>Limit per page</label>
            </b-input-group-prepend>
            <b-form-select
              :options="tblData.pageOptions"
              :plain="true"
              v-model="tblData.limit"
              @change="refresh"
            />
          </b-input-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
     <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Agen/Langganan"
      :centered="true"
    >
      <lku-customerkoran @click="onSelectKoranCust"></lku-customerkoran>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import koran_pesanan from "../../apis/koran_pesanan_buktiiklan";
import lkuCustomerkoran from "../lookup/lkuKoranCust";

import toastr from "mini-toastr";
import moment from "moment";
toastr.init();

export default {
  components: { Loading , lkuCustomerkoran},
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showFilter: true,
      isLoading: true,
      showReport: false,
      lkuKoranCustShow:false,
      terpilih: { customer_id: "" },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        pageOptions: [10, 20, 30, 50, 70, 90, 120],
        sortBy: "tanggal",
        sortDesc: true,
        koran: "1",
        tgl1:moment().format('YYYY-MM-DD'),
        tgl2:moment().format('YYYY-MM-DD'),        
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "tanggal",
          thStyle: "width:100px",
          label: "Tanggal Kirim",
          sortable: true
        },
        {
          key: "noorderiklan",
          thStyle: "width:100px",
          label: "No order iklan",
          sortable: true
        },
        {
          key: "CustCode",
          thStyle: "width:100px",
          label: "Kode Agen",
          sortable: true
        },
        {
          key: "CustName",
          thStyle: "width:200px",
          label: "Nama Agen",
          sortable: true
        },

        {
          key: "Address",
          label: "Alamat Penagihan"
        },
        {
          key: "City",
          label: "Kota",
          sortable: true
        },
        {
          key: "PhoneNo",
          label: "Phone/Fax",
          thStyle: "width:150px"
        },
        {
          key: "kiriman_code",
          label: "Kode Kiriman",
          thStyle: "width:150px",
          sortable: true
        },
        {
          key: "jmlkirim",
          label: "Jumlah Kiriman",
          thStyle: "width:150px",
          sortable: true
        }
        // {
        //   key: "collector",
        //   label: "Kolektor",
        //   thStyle: "width:150px",
        //   sortable: true
        // },
        // {
        //   key: "sales",
        //   label: "Sales (AE)",
        //   thStyle: "width:150px",
        //   sortable: true
        // }
      ];
      return fields;
    }
  },
  // watch: {
  //   tgl1(val) {
  //     if (val !== null) this.tblData.tgl1 = moment(val).format("YYYY-MM-DD");
  //     else this.tblData.tgl1 = null;
  //   },
  //   tgl2(val) {
  //     if (val !== null) this.tblData.tgl2 = moment(val).format("YYYY-MM-DD");
  //     else this.tblData.tgl2 = null;
  //   }
  // },
  // created: async function() {},
  methods: {
    onSelectKoranCust: function(_selected) {
      this.tblData.CustName = _selected.CustName;
      this.tblData.customer_id = _selected.customer_id;
      this.lkuKoranCustShow = false;
    },
    // formatDate(val) {
    //   if (val !== "") {
    //     let date = new Date(val);
    //     return moment(date).format("DD MMMM YYYY");
    //   } else {
    //     return null;
    //   }
    // },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      this.tblData.tgl1 = this.tblData.tgl1
        ? moment(this.tblData.tgl1).format("YYYY-MM-DD")
        : null;
      this.tblData.tgl2 = this.tblData.tgl2
        ? moment(this.tblData.tgl2).format("YYYY-MM-DD")
        : null;

      const list = await koran_pesanan.list(this.tblData);
      list.forEach((el, idx) => {
        list[idx].tanggal = moment(el.tanggal).format("YYYY-MM-DD");
      });

      // this.tblData.tgl1 = this.tblData.tgl1
      //   ? new Date(this.tblData.tgl1)
      //   : null;
      // this.tblData.tgl2 = this.tblData.tgl2
      //   ? new Date(this.tblData.tgl2)
      //   : null;

      this.isLoading = false;
      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.customer_id = "";
      this.tblData.CustName = "";
      this.tblData.address = "";
      this.tblData.noorderiklan = "";
      this.tblData.City = "";
      this.tblData.tgl1 = null;
      this.tblData.tgl2 = null;
      this.refresh();
    },
    add: function() {
      router.push({ name: "koran.pesananbuktiiklanfrm" });
    },
    edit: function() {
      if (this.terpilih.tablekey) {
        router.push({
          name: "koran.pesananbuktiiklanfrm",
          params: { tablekey: this.terpilih.tablekey }
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.terpilih.customer_id) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Deleted!");
      }
    },
    deleteData: async function() {
      try {
        await koran_pesanan.remove(this.terpilih);
        toastr.success("Delete record successfully");
        this.refresh();
      } catch (error) {
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    rowClicked(record, index) {
      if (this.terpilih.customer_id == record.customer_id) {
        this.edit();
      } else {
        if (this.terpilih && this.terpilih._rowVariant) {
          delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant = "info";
        this.$forceUpdate();
      }
    },

    exportxls: async function() {
      this.isLoading = true;
      try {
        const response = await koran_pesanan.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push("/koran/home");
    }
  }
};
</script>